<template lang="html">
  <div class="">
    <h1>yes is {{msg}}</h1>
  </div>
</template>

<script>
export default {
  data(){
    return {
      msg:'zhangwei'
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// User.vue?29a92d76